var map = {
	"./bef2.svg": 995,
	"./eg2.svg": 686,
	"./mag2.svg": 774,
	"./spany2.svg": 373,
	"./uzl2.svg": 119,
	"./vagyon2.svg": 866,
	"./visszav2.svg": 418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 142;